import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import RiskChart from "@/components/ScaleChart/RiskChart";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxRiskScorePanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxRiskScorePanel: props } = dashboard;
	if (!props) {
		return null;
	}

	const { sections } = props;

	return (
		<ContentBlock id="fxRiskScorePanel" data-testid="FxRiskScorePanel" flex={flex} tabIndex={-1}>
			{sections.map((section, i) => {
				return <RiskChart key={i} {...section} collapsible={section.collapsible} />;
			})}
		</ContentBlock>
	);
};
